(() => {
  const mobile=matchMedia('(max-width:999px)');
  let lastY=window.scrollY,queued=false;

  /* The category / filter strip used to rewrite its class on EVERY scroll frame,
     with only a 3px threshold. Measured 72 class changes across 85 scroll steps -
     that constant rewriting is what made the bar flicker while scrolling.
     Now: only touch the DOM when the state actually changes, require sustained
     travel in one direction, and rate-limit the flips. */
  const SCROLL_TRAVEL = 14;   // px of sustained movement before reacting
  const FLIP_COOLDOWN = 260;  // ms minimum between show/hide changes
  const SHOW_ABOVE    = 60;   // always visible near the top of the page
  let travel = 0, lastFlip = 0;

  function setHidden(strip, hide) {
    if (strip.classList.contains('is-scroll-hidden') === hide) return false;  // no redundant write
    strip.classList.toggle('is-scroll-hidden', hide);
    strip.inert = hide;
    return true;
  }

  function updateStrip() {
    queued = false;
    const y = window.scrollY, delta = y - lastY;
    lastY = y;
    const now = (performance && performance.now) ? performance.now() : Date.now();

    document.querySelectorAll('[data-mobile-category-autohide]').forEach(strip => {
      if (!mobile.matches || y < SHOW_ABOVE || strip.contains(document.activeElement)) {
        travel = 0;
        setHidden(strip, false);
        return;
      }
      if (delta === 0) return;
      if ((delta > 0) !== (travel > 0)) travel = 0;   // direction changed - start again
      travel += delta;
      if (Math.abs(travel) < SCROLL_TRAVEL) return;
      if (now - lastFlip < FLIP_COOLDOWN) return;
      if (setHidden(strip, travel > 0)) lastFlip = now;
      travel = 0;
    });
  }
  window.addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(updateStrip);}},{passive:true});
  mobile.addEventListener('change',updateStrip);
  const close=panel=>{if(!panel)return;panel.open=false;panel.removeAttribute('open');document.querySelectorAll('[aria-controls="'+panel.id+'"]').forEach(button=>button.setAttribute('aria-expanded','false'));};
  document.addEventListener('facet:criteria-changed',()=>{if(mobile.matches){close(document.getElementById('facet-filters'));close(document.getElementById('sort-by-popover'));}});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){close(document.querySelector('#facet-filters[open]'));close(document.querySelector('#sort-by-popover[open]'));}});
  document.addEventListener('click',event=>{
    const panel=event.target.closest('#facet-filters,#sort-by-popover');
    if(panel&&event.target.closest('[data-action="close"],.drawer__overlay,.popover__overlay'))close(panel);
  });
})();
